import { TemplateData, TemplateParams } from '.';

const profileSummaryEmail = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        {{summaryContent}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.profileSummaryEmailSubject}`
  },
  placeholders: {
    summaryContent: {
      label: messages.emailSummaryOfNewEvents
    },
    ...defaultPlaceholders
  },
  title: messages.profileSummaryEmailSubject
});

export default profileSummaryEmail;
